import { runImpactCalculateTourCo2ForSequence } from '@/domain/impact-calculate-tour/actions/run-impact-calculate-tour-co2-for-sequence';
import { createAppAsyncThunk } from '@/domain/store.thunk';

import { ImpactCo2Answer } from '../../entities/question.entity';
import { deleteImpactCo2Answer } from '../delete-impact-co2-answer.action';

type Params = {
  sequenceId: number;
  answer: ImpactCo2Answer;
};

type Result = void;

export const deleteImpactCo2AnswerTourSequence = createAppAsyncThunk(
  'impactCo2/deleteImpactCo2AnswerTourSequence',
  async ({ sequenceId, answer }: Params, { dispatch }): Promise<Result> => {
    await dispatch(
      deleteImpactCo2Answer({
        projectId: sequenceId,
        answer,
        recalculateAfterSubmit: false,
      }),
    );
    dispatch(runImpactCalculateTourCo2ForSequence({ sequenceId }));
  },
);
